import React from "react";
import { FiUpload } from "react-icons/fi";
import "./Header.css";

export const NavBar = ({ onFileUpload }) => {
  return (
    <header className="finance-header">
      <nav className="nav-bar">
        <label htmlFor="csv-upload" className="upload-button">
          <FiUpload /> Upload CSV
          <input
            type="file"
            id="csv-upload"
            accept=".csv"
            multiple
            onChange={onFileUpload}
            style={{ display: "none" }}
          />
        </label>
        <h1>Full Finance Dashboard</h1>
      </nav>
    </header>
  );
};
